import { createMuiTheme } from '@material-ui/core/styles';
import { palette } from './palette';
import { typography } from './typography';
export default createMuiTheme({
    palette: palette,
    typography: typography,
});
//# sourceMappingURL=baseTheme.js.map